import { css } from '@mui/material';

import type { ThemeOptions } from '@mui/material';

export const modalThemes: ThemeOptions['components'] = {
  MuiDialog: {
    styleOverrides: {
      container: () => css`
        position: relative;
        overflow-x: auto;
      `,
      paper: ({ theme }) => css`
        margin: 0;
        width: 100%;
        padding: 0 32px;
        box-shadow: ${theme.shadows[6]};
        min-width: 360px;
      `,
      paperWidthSm: () => css`
        max-width: 560px !important;
      `,
      paperWidthMd: () => css`
        max-width: 720px !important;
      `,
      paperWidthLg: () => css`
        max-width: 1024px !important;
      `,
      paperFullScreen: () => css`
        display: flex;
        flex-direction: column;
        overflow: hidden;

        & .MuiDialogContent-root {
          flex: 1;
          overflow-y: auto;
        }
      `,
    },
  },
};
